(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["switory-account-menu-v1"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>document.querySelectorAll('.swam-v1[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;}));
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.swam-v1[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["switory-support-widget"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('switory-support-dismiss')) {
    customElements.define('switory-support-dismiss', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const details = this.querySelector('details');
        if (!details) return;
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-support-open], [data-swa-support], a[href^="mailto:info@sugle-germany.de"]');
          if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const otherPanel = trigger.closest('details');
          if (otherPanel) otherPanel.open = false;
          details.open = true;
          details.querySelector('summary')?.focus({ preventScroll: true });
        }, { signal });
        document.addEventListener('click', (event) => {
          if (details.open && !event.composedPath().includes(this)) details.open = false;
        }, { capture: true, signal });
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !details.open) return;
          const returnFocus = this.contains(document.activeElement);
          details.open = false;
          if (returnFocus) details.querySelector('summary')?.focus();
        }, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
